import { G } from '@/components/gold/theme'
import loginBgM from '@/assets/image/gold/login_bg_m.png'
import styled from 'styled-components'

/* ---------- ver2(gold) 일반 팝업·알림·확인창 ----------
 *  gold8.bet .alertDialog(PC) · m.gold8.bet 알림 실측: 흰 상자(PC 폭 350, 모바일 화면 폭 - 18), 모서리 5, 화면 세로 가운데,
 *  머리말(「ヒント」) + 회색 선, 본문 + 회색 선, 아래 오른쪽 파란(#375fd2) 버튼. 바깥 막 #000c.
 *  (gold 는 머리말 오른쪽에 접속 IP, 아래 왼쪽에 고객센터 링크도 두지만 우리는 그 정보가 없어 뺐다) */
export const GoldAlertOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10010;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 9px;
  background: rgba(0, 0, 0, 0.8);
  overflow-y: auto;
`

export const GoldAlertBox = styled.div`
  width: 350px;
  max-width: 100%;
  border-radius: 5px;
  background: #fff;
  font-family: Arial, "PingFang SC", "Microsoft YaHei", sans-serif;
  color: #000;
  text-align: left;
  @media (max-width: 850px) { width: 100%; }
`

export const GoldAlertHeader = styled.div`
  padding: 15px;
  border-bottom: 1px solid #c0c0c0;
  font-size: 16px;
  line-height: 1.4;
  @media (max-width: 850px) { font-size: 17px; }
`

export const GoldAlertBody = styled.div`
  padding: 15px;
  border-bottom: 1px solid #c0c0c0;
  font-size: 14px;
  line-height: 1.5;
  white-space: pre-line;
  word-break: break-word;
  @media (max-width: 850px) { font-size: 16px; }
`

export const GoldAlertFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  min-height: 40px;
  padding: 15px;
`

/* 전역 button 규칙(높이·여백)에 눌리지 않게 && 로 명시도를 올린다 */
export const GoldAlertBtn = styled.button.attrs({ type: 'button' })`
  && {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 27px;
    min-width: 60px;
    padding: 0 10px;
    border: ${({ $sub }) => ($sub ? '1px solid #c0c0c0' : '0')};
    border-radius: 3px;
    background: ${({ $sub }) => ($sub ? '#fff' : '#375fd2')};
    font-size: 14px;
    line-height: 1;
    color: ${({ $sub }) => ($sub ? '#333' : '#fff')};
    cursor: pointer;
  }
  @media (max-width: 850px) {
    && {
      height: 30px;
      min-width: 64px;
      padding: 0 14px;
      font-size: 15px;
    }
  }
`

/* ---------- ver2(gold) 로그인 창 ----------
 *  PC: gold8.bet .loginDialog — 화면 위 20%, 폭 400, 바탕 #1a242d, 각진 상자, 바깥 막 #000c.
 *  모바일: m.gold8.bet /Login — 검은 둥근 카드, 금색 제목·라벨. */
export const GoldLoginOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, ${({ $mobile }) => ($mobile ? 0.85 : 0.8)});
  overflow-y: auto;
`

export const GoldLoginBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${({ $mobile }) => ($mobile
    ? `position: relative;
       width: calc(100% - 24px);
       margin: 0 auto;
       padding: 18px 20px 34px;
       border-radius: 14px;
       background: #000;`
    : `position: absolute;
       left: 50%;
       transform: translateX(-50%);
       top: 20%;
       width: 400px;
       min-height: 500px;
       padding: 45px 30px 30px;
       background: ${G.panel};`)}
`

export const GoldLoginClose = styled.button`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  cursor: pointer;
  ${({ $mobile }) => ($mobile
    ? `top: -58px; right: 4px; width: 42px; height: 42px; border-radius: 50%;
       background: #000; font-size: 24px; color: #fff;`
    : `top: 20px; right: 22px; width: 24px; height: 24px; background: none;
       font-size: 20px; color: #999;`)}
`

export const GoldLoginLogo = styled.img`
  width: 190px;
  height: 60px;
  margin-bottom: 24px;
  object-fit: contain;
`

export const GoldLoginTitle = styled.p`
  margin: ${({ $mobile }) => ($mobile ? '0 0 26px' : '0 0 29px')};
  text-align: center;
  font-size: ${({ $mobile }) => ($mobile ? '18px' : '24px')};
  font-weight: 700;
  color: ${({ $mobile }) => ($mobile ? '#d29a12' : '#fff')};
`

/* ---------- ver2(gold) 모바일 로그인 화면 — m.gold8.bet /Login 실측(390 기준) ----------
 *  배경: 위쪽 룰렛 사진(750×300) + 아래 어두운 바탕, 로고 왼쪽 위(9,16 · 높이 32),
 *  닫기 검은 원 오른쪽 위, 카드 위에서 79px, 카드 아래 언어 상자. */
export const GoldMLoginPage = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  padding: 79px 0 40px;
  overflow-y: auto;
  background: #1c1c1e url(${loginBgM}) center top / 100% auto no-repeat;
`

export const GoldMLoginLogo = styled.img`
  position: absolute;
  top: 16px;
  left: 9px;
  height: 32px;
  width: auto;
`

export const GoldMLoginClose = styled.button`
  position: absolute;
  top: 10px;
  right: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: #000;
  font-size: 18px;
  color: #fff;
  cursor: pointer;
`

export const GoldMLoginLang = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 14px;
`
